// @ts-nocheck
import React, { useEffect, useState, useContext } from 'react';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import TaskItem from '../../TaskItem';
import { IProjectTaskModel } from '../../../models/ProjectTaskModel';
import { ICard } from '../models/BoardModel';
import { useActions } from '../../../hooks/useActions';
import DropDownMenu from '../../DropDownMenuMui';
import RenameEntityDialog from '../../RenameEntityDialog';
import DeleteEntityDialog from '../../DeleteEntityDialog';
import { ReleaseModal } from './ReleaseModal';
import { IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { AlertDialog } from './AlertDialog';
import { PhaseModal } from './ProjectsPhaseModal';
import NoPermissionDialog from '../../NoPermissionDialog';
import { checkPermission } from '../../../helpers/PermissionsHelper';
import { ERROR_MESSAGES } from '../../../models/constants';
import { usePageKey } from '../../../../shared/contexts/PageKeyContext';
import { FrontendVisibility } from '../../../models/ISettingsFrontend';
import { useLaneVisibility } from '../../../hooks/useLaneVisibility';
interface ProjectsLaneHeaderProps {
  id: string;
  cards: ICard<IProjectTaskModel>[];
  title: string;
}

enum LaneMenuItems {
  ArchiveAll = 0,
  Rename = 1,
  GetReleasesAll = 2,
  DeletePhase = 3,
  GetPhaseAll = 4,
}

export const ProjectsLaneHeader = React.memo(({ id, cards, title }: ProjectsLaneHeaderProps) => {
  const { board, currentProjectReleaseId, project } = useTypedSelector((state) => state.project);
  const releases = useTypedSelector((state) => state.project.releaseDropdown);
  const phases = useTypedSelector((state) => state.project.phaseDropdown);

  const [releasesData, setReleasesData] = useState(releases);
  const [phaseData, setPhaseData] = useState(phases);
  const [openedModal, setOpenedModal] = useState<LaneMenuItems | undefined>(undefined);
  const handleOptionSelect = (selectedOption: number) => {
    moveToReleaseAllPhaseTasks(board.boardId, id, selectedOption, currentProjectReleaseId);
  };
  const handlePhaseOptionSelect = (selectedOption: number) => {
    moveToPhaseAllTasks(board.boardId, selectedOption, id, currentProjectReleaseId);
  };

  useEffect(() => {
    if (releases) {
      setReleasesData(releases);
    }
  }, [releases]);

  useEffect(() => {
    if (phases) {
      setPhaseData(phases);
    }
  }, [phases]);

  const lane = board.lanes.find((lane) => lane.id === id);
  const currentPhase = project.projectPhases
    ? project.projectPhases.find((phase) => Number(phase.id) === Number(id))
    : null;
  const serverVisibility = currentPhase?.settingsFrontend?.Visibility ?? FrontendVisibility.Open;
  const laneMenuItems = [
    {
      name: 'Archive all',
      value: LaneMenuItems.ArchiveAll,
      isDisabled: !lane || lane.cards.length <= 0,
    },
    {
      name: 'Move to release',
      value: LaneMenuItems.GetReleasesAll,
      isDisabled: !lane || lane.cards.length <= 0 || project.projectReleases.length <= 0,
    },
    {
      name: 'Move to phase',
      value: LaneMenuItems.GetPhaseAll,
      isDisabled: false,
    },
    {
      name: 'Rename',
      value: LaneMenuItems.Rename,
      isDisabled: currentPhase ? currentPhase.isCommon : false,
    },
    {
      name: 'Delete phase',
      value: LaneMenuItems.DeletePhase,
      isDisabled: false,
      additionalCssClass: 'delete-phase',
    },
  ];
  const [isLaneMenuOpen, setIsLaneMenuOpen] = useState(false);
  const { archiveAllPhaseTasks, renamePhase, deletePhase, changeVisibilityOfLanePhase } =
    useActions();
  const { moveToReleaseAllPhaseTasks } = useActions();
  const { moveToPhaseAllTasks } = useActions();
  const { getReleasesAllPhaseTasks } = useActions();
  const { getPhasesAllPhaseTasks } = useActions();
  const [hasPermissionError, setHasPermissionError] = useState<string | null>(null);

  const closeModal = () => {
    setOpenedModal(undefined);
  };
  const pageKey = usePageKey();

  const handleOnLaneMenuItemClick = async (laneMenuItem: LaneMenuItems) => {
    const actionName =
      laneMenuItem === LaneMenuItems.Rename
        ? 'renamePhase'
        : laneMenuItem === LaneMenuItems.DeletePhase
          ? 'deletePhase'
          : null;

    if (actionName) {
      const hasPermission = await checkPermission(actionName, pageKey);
      if (!hasPermission) {
        setHasPermissionError(
          actionName === 'renamePhase'
            ? ERROR_MESSAGES.RENAME_NO_PERMISSION
            : ERROR_MESSAGES.DELETE_NO_PERMISSION
        );
        return;
      }
    }

    if (laneMenuItem === LaneMenuItems.GetReleasesAll) {
      getReleasesAllPhaseTasks(board.boardId);
    }
    if (laneMenuItem === LaneMenuItems.GetPhaseAll) {
      getPhasesAllPhaseTasks(board.boardId);
    }

    setOpenedModal(laneMenuItem);
  };

  const _renamePhase = (newPhaseName: string) =>
    renamePhase({
      id: +id,
      value: newPhaseName,
    });

  const _deletePhase = () =>
    deletePhase({
      phaseId: +id,
      projectId: +project.id,
    });

  const [laneMenuAnchor, setLaneMenuAnchor] = useState<null | HTMLElement>(null);

  const containsCards =
    project.projectPhases.filter((p) => p.phaseName === title)[0]?.isContainsCardsAnotherReleases ||
    board.lanes.find((l) => l.id == id)?.cards.length > 0;

  const toggleLaneMenuAnchor = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setLaneMenuAnchor(event.currentTarget);
    setIsLaneMenuOpen(true);
  };

  const { isLaneCollapsed, isVisibilityUpdating, visibilityButtonRef, toggleLaneVisibility } =
    useLaneVisibility({
      serverVisibility,
      projectId: project.id,
      phaseId: Number(id),
      changeVisibilityOfLanePhase,
    });

  if (!lane) return <></>;
  return (
    <>
      <div className="phase-header">
        <div className="phase-header__first">
          <h5 className="phase-header__item mb-0">{title}</h5>
          <h6 className="phase-header__item mb-0">
            {cards.length}/{lane.cards.length}
          </h6>
        </div>
        <div className="phase-header__second">
          <IconButton size="small" sx={{ p: 0 }} onClick={toggleLaneMenuAnchor}>
            <MoreVertIcon />
          </IconButton>
          <button
            ref={visibilityButtonRef}
            type="button"
            className={
              isLaneCollapsed ? 'visibility-lane-button__close' : 'visibility-lane-button__open'
            }
            aria-label={isLaneCollapsed ? 'Expand lane' : 'Collapse lane'}
            onClick={toggleLaneVisibility}
            disabled={isVisibilityUpdating}
          />
          {isLaneMenuOpen && (
            <DropDownMenu
              menuItems={laneMenuItems}
              onChange={handleOnLaneMenuItemClick}
              anchorEl={laneMenuAnchor}
              setAnchorEl={setIsLaneMenuOpen}
            />
          )}
        </div>
      </div>
      {openedModal === LaneMenuItems.GetReleasesAll && releasesData.length > 0 && (
        <ReleaseModal
          releasesData={releasesData}
          isOpen={true}
          onClose={closeModal}
          onMove={handleOptionSelect}
        />
      )}
      {openedModal === LaneMenuItems.GetPhaseAll && phaseData.length > 0 && (
        <PhaseModal
          phasesData={phaseData}
          isOpen={true}
          onClose={closeModal}
          onMove={handlePhaseOptionSelect}
        />
      )}
      {openedModal === LaneMenuItems.Rename && (
        <RenameEntityDialog
          isOpen={true}
          onRename={_renamePhase}
          onClose={closeModal}
          headerTitle={`Rename phase "${title}"`}
          currentEntityName={title}
        />
      )}
      {openedModal === LaneMenuItems.ArchiveAll && (
        <AlertDialog
          message="Do you want to archive all tasks?"
          action={() => archiveAllPhaseTasks(board.boardId, id, currentProjectReleaseId)}
          isOpen={true}
          onClose={closeModal}
        />
      )}
      {openedModal === LaneMenuItems.DeletePhase && (
        <DeleteEntityDialog
          isOpen={true}
          containsCards={containsCards}
          onDelete={_deletePhase}
          onClose={closeModal}
          headerTitle={
            containsCards
              ? `You can't delete the phases with items`
              : `Are you sure you want to delete "${title}" phase?`
          }
        />
      )}
      {hasPermissionError && (
        <NoPermissionDialog
          isOpen={!!hasPermissionError}
          onClose={() => setHasPermissionError(null)}
          message={hasPermissionError}
        />
      )}
    </>
  );
});

export default TaskItem;
